// extracted by mini-css-extract-plugin
module.exports = {"read_more":"style_read_more__6eeHt","big_card":"style_big_card__3ETnz","big_card_cover":"style_big_card_cover__Zk9r7","card_cover":"style_card_cover__Kp0Xo"};